import request from '@/utils/request'

// 查询星河村-话题列表
export function listTopic(query) {
  return request({
    url: '/community/topic/list',
    method: 'get',
    params: query
  })
}

// 查询星河村-话题详细
export function getTopic(id) {
  return request({
    url: '/community/topic/' + id,
    method: 'get'
  })
}

// 新增星河村-话题
export function addTopic(data) {
  return request({
    url: '/community/topic',
    method: 'post',
    data: data
  })
}

// 修改星河村-话题
export function updateTopic(data) {
  return request({
    url: '/community/topic',
    method: 'put',
    data: data
  })
}

// 删除星河村-话题
export function delTopic(id) {
  return request({
    url: '/community/topic/' + id,
    method: 'delete'
  })
}
